import { useQuery } from 'react-query';
import RestHttpClient from '../../../common/RestHttpClient';

export const overlayDetailQueryKey = (cmsId?: string) =>
  ['dashboard', 'detail', cmsId] as const;

export const overlayReportQueryKey = (cmsId?: string) =>
  ['dashboard', 'report', cmsId] as const;

export const overlayRkvConfigQueryKey = (rkv?: string) =>
  ['dashboard', 'rkvConfig', rkv] as const;

export const overlayTypeCertificateQueryKey = (cmsId?: string, dealId?: number) =>
  ['dashboard', 'typeCertificate', cmsId, dealId] as const;

export function useOverlayDetailQuery(cmsId?: string) {
  return useQuery({
    queryKey: overlayDetailQueryKey(cmsId),
    queryFn: async () => {
      const { data } = await RestHttpClient.getDetail(cmsId!);
      return data;
    },
    enabled: !!cmsId,
    keepPreviousData: false,
    staleTime: 60_000,
  });
}

export function useOverlayReportQuery(cmsId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: overlayReportQueryKey(cmsId),
    queryFn: async () => {
      const { data } = await RestHttpClient.getReport(cmsId!);
      return data;
    },
    enabled: !!cmsId && enabled,
    staleTime: 60_000,
  });
}

export function useOverlayRkvConfigQuery(rkv?: string) {
  return useQuery({
    queryKey: overlayRkvConfigQueryKey(rkv),
    queryFn: async () => {
      const { data } = await RestHttpClient.getRkvConfiguration(rkv!);
      return data;
    },
    enabled: !!rkv,
    staleTime: 60_000,
  });
}

export function useOverlayTypeCertificateQuery(cmsId?: string, dealId?: number) {
  return useQuery({
    queryKey: overlayTypeCertificateQueryKey(cmsId, dealId),
    queryFn: async () => {
      if (!dealId) return undefined;
      return await RestHttpClient.getTypeCertificate(dealId);
    },
    enabled: !!cmsId && !!dealId,
    staleTime: 60_000,
  });
}
